import { render } from "./Church.vue?vue&type=template&id=0b3acb4e&scoped=true"
import script from "./Church.vue?vue&type=script&lang=js"
export * from "./Church.vue?vue&type=script&lang=js"

import "./Church.vue?vue&type=style&index=0&id=0b3acb4e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eszti-isti.donko.hu/eszti-isti.donko.hu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3acb4e"]])

export default __exports__